import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", {
  value,
  configurable: true
});

// src/fareCode.ts
var _fareKeys = {
  DoorToDoorV2: null,
  PortToPortV2: null,
  Essential: null,
  Plus: null,
  Basic: null,
  LastMinute: null
};
var fareKeys = /* @__PURE__ */__name(() => _fareKeys, "fareKeys");
var FARE_CODES = Object.keys(_fareKeys);
var farePriority = {
  DoorToDoorV2: 6,
  PortToPortV2: 5,
  Essential: 4,
  Plus: 1,
  Basic: 2,
  LastMinute: 3
};

// src/fareCodeMapping.ts
import { match, P } from "ts-pattern";
var KnownResFareCodes = ["K3", "KB", "KV", "03", "CB", "GV", "WC", "S3", "SB", "SV", "U3", "UB", "UL"];
var KnownPackageTypes = ["AirSea", "CruiseOnly"];
var iTravelFeaturesFor = /* @__PURE__ */__name(request => match(request).with(iTravelWebFeatures("DoorToDoorV2", "Classic"), () => iTravelFeatures("D2D", "Package")).with(iTravelWebFeatures("PortToPortV2", "Classic"), () => iTravelFeatures("P2P", "CruiseOnly")).with(iTravelWebFeatures("Essential", "Classic"), () => iTravelFeatures("ESS", "CruiseOnly")).with(iTravelWebFeatures("DoorToDoorV2", "Expedition"), () => iTravelFeatures("D2D", "Package")).with(iTravelWebFeatures("PortToPortV2", "Expedition"), () => iTravelFeatures("P2P", "Package")).with(iTravelWebFeatures("Essential", "Expedition"), () => iTravelFeatures("ESS", "Package")).with(iTravelWebFeatures("Plus", "Classic"), () => void 0).with(iTravelWebFeatures("Basic", "Classic"), () => void 0).with(iTravelWebFeatures("LastMinute", "Classic"), () => void 0).with(iTravelWebFeatures("Plus", "Expedition"), () => void 0).with(iTravelWebFeatures("Basic", "Expedition"), () => void 0).with(iTravelWebFeatures("LastMinute", "Expedition"), () => void 0).exhaustive(), "iTravelFeaturesFor");
var resFeaturesFor = /* @__PURE__ */__name(request => match(request).with(webFeatures("DoorToDoorV2", "Single", "AirSea"), () => resFeatures("03", "AirSea", "V2")).with(webFeatures("DoorToDoorV2", "Combo", "AirSea"), () => resFeatures("CB", "AirSea", "V2")).with(webFeatures("DoorToDoorV2", "Grand", "AirSea"), () => resFeatures("GV", "AirSea", "V2")).with(webFeatures("DoorToDoorV2", "World", "AirSea"), () => resFeatures("WC", "AirSea", "V2")).with({
  fareCode: "DoorToDoorV2",
  packageType: "CruiseOnly"
}, () => void 0).with(webFeatures("PortToPortV2", "Single", "CruiseOnly"), () => resFeatures("03", "CruiseOnly", "V2")).with(webFeatures("PortToPortV2", "Combo", "CruiseOnly"), () => resFeatures("CB", "CruiseOnly", "V2")).with(webFeatures("PortToPortV2", "Grand", "CruiseOnly"), () => resFeatures("GV", "CruiseOnly", "V2")).with(webFeatures("PortToPortV2", "World", "CruiseOnly"), () => resFeatures("WC", "CruiseOnly", "V2")).with({
  fareCode: "PortToPortV2",
  packageType: "AirSea"
}, () => void 0).with(webFeatures("Essential", "Single", "CruiseOnly"), () => resFeatures("K3", "CruiseOnly", "V2")).with(webFeatures("Essential", "Combo", "CruiseOnly"), () => resFeatures("KB", "CruiseOnly", "V2")).with(webFeatures("Essential", "Grand", "CruiseOnly"), () => resFeatures("KV", "CruiseOnly", "V2")).with({
  fareCode: "Essential",
  comboType: "World"
}, () => void 0).with({
  fareCode: "Essential",
  packageType: "AirSea"
}, () => void 0).with(webFeatures("Plus", "Single", "CruiseOnly"), () => resFeatures("S3", "CruiseOnly", "V3")).with(webFeatures("Plus", "Combo", "CruiseOnly"), () => resFeatures("SB", "CruiseOnly", "V3")).with(webFeatures("Plus", "Grand", "CruiseOnly"), () => resFeatures("SV", "CruiseOnly", "V3")).with(webFeatures("Plus", "World", "CruiseOnly"), () => resFeatures("WC", "CruiseOnly", "V3")).with(webFeatures("Basic", "Single", "CruiseOnly"), () => resFeatures("U3", "CruiseOnly", "V3")).with(webFeatures("Basic", "Combo", "CruiseOnly"), () => resFeatures("UB", "CruiseOnly", "V3")).with({
  fareCode: "Basic",
  comboType: P.union("Grand", "World")
}, () => void 0).with(webFeatures("LastMinute", "Single", "CruiseOnly"), () => resFeatures("UL", "CruiseOnly", "V3")).with({
  fareCode: "LastMinute",
  comboType: P.union("Combo", "Grand", "World")
}, () => void 0).with({
  fareCode: P.union("Plus", "Basic", "LastMinute"),
  packageType: "AirSea"
}, () => void 0).exhaustive(), "resFeaturesFor");
var webFeaturesFor = /* @__PURE__ */__name(request => match(request).with({
  resFareCode: P.union(...KnownResFareCodes)
}, webFeaturesForKnownFareCode).otherwise(() => void 0), "webFeaturesFor");
var webFeaturesForKnownFareCode = /* @__PURE__ */__name(request => match(request).with(resFeatures("03", "AirSea", "V2"), () => webFeatures("DoorToDoorV2", "Single", "AirSea")).with(resFeatures("03", "CruiseOnly", "V2"), () => webFeatures("PortToPortV2", "Single", "CruiseOnly")).with(resFeatures("CB", "AirSea", "V2"), () => webFeatures("DoorToDoorV2", "Combo", "AirSea")).with(resFeatures("CB", "CruiseOnly", "V2"), () => webFeatures("PortToPortV2", "Combo", "CruiseOnly")).with(resFeatures("GV", "AirSea", "V2"), () => webFeatures("DoorToDoorV2", "Grand", "AirSea")).with(resFeatures("GV", "CruiseOnly", "V2"), () => webFeatures("PortToPortV2", "Grand", "CruiseOnly")).with(resFeatures("WC", "AirSea", "V2"), () => webFeatures("DoorToDoorV2", "World", "AirSea")).with(resFeatures("WC", "CruiseOnly", "V2"), () => webFeatures("PortToPortV2", "World", "CruiseOnly")).with(resFeatures("K3", "CruiseOnly", "V2"), () => webFeatures("Essential", "Single", "CruiseOnly")).with({
  resFareCode: "K3",
  packageType: "AirSea"
}, () => void 0).with(resFeatures("KB", "CruiseOnly", "V2"), () => webFeatures("Essential", "Combo", "CruiseOnly")).with({
  resFareCode: "KB",
  packageType: "AirSea"
}, () => void 0).with(resFeatures("KV", "CruiseOnly", "V2"), () => webFeatures("Essential", "Grand", "CruiseOnly")).with({
  resFareCode: "KV",
  packageType: "AirSea"
}, () => void 0).with({
  pricingVersion: "V2"
}, () => void 0).with(resFeatures("S3", "CruiseOnly", "V3"), () => webFeatures("Plus", "Single", "CruiseOnly")).with(resFeatures("SB", "CruiseOnly", "V3"), () => webFeatures("Plus", "Combo", "CruiseOnly")).with(resFeatures("SV", "CruiseOnly", "V3"), () => webFeatures("Plus", "Grand", "CruiseOnly")).with(resFeatures("WC", "CruiseOnly", "V3"), () => webFeatures("Plus", "World", "CruiseOnly")).with(resFeatures("U3", "CruiseOnly", "V3"), () => webFeatures("Basic", "Single", "CruiseOnly")).with(resFeatures("UB", "CruiseOnly", "V3"), () => webFeatures("Basic", "Combo", "CruiseOnly")).with(resFeatures("UL", "CruiseOnly", "V3"), () => webFeatures("LastMinute", "Single", "CruiseOnly")).with({
  packageType: "AirSea"
}, () => void 0).with({
  pricingVersion: "V3"
}, () => void 0).exhaustive(), "webFeaturesForKnownFareCode");
var webFeatures = /* @__PURE__ */__name((fareCode, comboType, packageType) => ({
  fareCode,
  comboType,
  packageType
}), "webFeatures");
var iTravelWebFeatures = /* @__PURE__ */__name((fareCode, cruiseType) => ({
  fareCode,
  cruiseType
}), "iTravelWebFeatures");
var resFeatures = /* @__PURE__ */__name((resFareCode, packageType, pricingVersion) => ({
  resFareCode,
  packageType,
  pricingVersion
}), "resFeatures");
var iTravelFeatures = /* @__PURE__ */__name((ratePlanTypeCode, packageType) => ({
  ratePlanTypeCode,
  packageType
}), "iTravelFeatures");
var webFeaturesByFlags = /* @__PURE__ */__name((resFareCode, _ref, pricingVersion) => {
  let {
    as_flag,
    co_flag
  } = _ref;
  return [as_flag ? webFeaturesFor({
    resFareCode,
    packageType: "AirSea",
    pricingVersion
  }) : void 0, co_flag ? webFeaturesFor({
    resFareCode,
    packageType: "CruiseOnly",
    pricingVersion
  }) : void 0].filter(isPresent);
}, "webFeaturesByFlags");
var allResFeaturesFor = /* @__PURE__ */__name(request => KnownPackageTypes.map(packageType => resFeaturesFor(_objectSpread(_objectSpread({}, request), {}, {
  packageType
}))).filter(isPresent), "allResFeaturesFor");
var isPresent = /* @__PURE__ */__name(x => x !== void 0, "isPresent");
var RES_FARES_BY_COMBO_TYPE = {
  Single: ["03", "K3", "S3", "U3", "UL"],
  Combo: ["CB", "KB", "SB", "UB"],
  Grand: ["GV", "KV", "SV"],
  World: ["WC"]
};
var resFareCodesForComboType = /* @__PURE__ */__name(comboType => {
  var _a;
  return (_a = RES_FARES_BY_COMBO_TYPE[comboType]) != null ? _a : [];
}, "resFareCodesForComboType");
export { FARE_CODES, allResFeaturesFor, fareKeys, farePriority, iTravelFeaturesFor, resFareCodesForComboType, resFeaturesFor, webFeaturesByFlags, webFeaturesFor };